const FEATURES = [
  {
    title: '热血战斗专场',
    desc: '从经典《龙珠》《海贼王》到《鬼灭之刃》《咒术回战》，最燃战斗场面一网打尽。',
    image: 'https://readdy.ai/api/search-image?query=Epic%20anime%20battle%20scene%20with%20dynamic%20action%20poses%2C%20vibrant%20energy%20effects%20in%20warm%20orange%20and%20gold%20tones%2C%20stylized%20characters%20mid-combat%2C%20dramatic%20lighting%20with%20lens%20flare%2C%20modern%20anime%20illustration%20style%2C%20high%20contrast%2C%20cinematic%20composition&width=800&height=500&seq=carousel-01&orientation=landscape',
    stat: '1200+ 部热血作品',
    tag: '热血',
  },
  {
    title: '奇幻异世界之旅',
    desc: '转生、冒险、魔法——探索《Re:Zero》《关于我转生变成史莱姆这档事》等奇幻大作。',
    image: 'https://readdy.ai/api/search-image?query=Fantasy%20anime%20world%20with%20magical%20landscape%2C%20floating%20islands%20and%20ancient%20ruins%2C%20soft%20ethereal%20lighting%20in%20teal%20and%20lavender%20tones%2C%20adventurer%20characters%20in%20foreground%2C%20dreamy%20atmosphere%2C%20anime%20illustration%20with%20rich%20details&width=800&height=500&seq=carousel-02&orientation=landscape',
    stat: '800+ 部奇幻作品',
    tag: '奇幻',
  },
  {
    title: '校园恋爱物语',
    desc: '《辉夜大小姐》《堀与宫村》等纯爱佳作，甜甜的校园恋爱一次看个够。',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20anime%20school%20scene%20with%20cherry%20blossom%20trees%20in%20full%20bloom%2C%20warm%20spring%20sunlight%20filtering%20through%20petals%2C%20soft%20pink%20and%20cream%20color%20palette%2C%20two%20characters%20walking%20together%2C%20gentle%20atmosphere%2C%20modern%20anime%20style&width=800&height=500&seq=carousel-03&orientation=landscape',
    stat: '600+ 部恋爱作品',
    tag: '恋爱',
  },
  {
    title: '搞笑日常治愈',
    desc: '《间谍过家家》《小林家的龙女仆》等欢乐日常番，笑到停不下来。',
    image: 'https://readdy.ai/api/search-image?query=Funny%20anime%20slice%20of%20life%20scene%20with%20colorful%20chibi%20characters%20in%20cozy%20living%20room%2C%20bright%20cheerful%20lighting%20with%20pastel%20colors%2C%20comedy%20expressions%2C%20warm%20home%20atmosphere%2C%20modern%20anime%20art%20style%2C%20wholesome%20vibe&width=800&height=500&seq=carousel-04&orientation=landscape',
    stat: '500+ 部搞笑作品',
    tag: '搞笑',
  },
  {
    title: '悬疑推理烧脑',
    desc: '《Death Note》《PSYCHO-PASS》等智斗神作，每一帧都让人屏住呼吸。',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20anime%20scene%20with%20dark%20atmospheric%20lighting%2C%20shadowy%20urban%20backdrop%2C%20detective%20characters%20in%20trench%20coat%2C%20moody%20blue-grey%20tones%20with%20dramatic%20rim%20light%2C%20suspenseful%20composition%2C%20modern%20anime%20illustration%20style&width=800&height=500&seq=carousel-05&orientation=landscape',
    stat: '400+ 部悬疑作品',
    tag: '悬疑',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">焦点专题</h2>
          <p className="text-sm text-foreground-500">精选动漫类型专题，发现你的下一部神作</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {FEATURES.map((item) => (
            <article
              key={item.title}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer hover:border-accent-200 transition-all duration-300"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-[11px] font-medium rounded-full bg-accent-500 text-background-50">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-base font-heading text-foreground-950 mb-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                  {item.desc}
                </p>
                <span className="text-xs text-primary-500 font-medium">{item.stat}</span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}